import { PaymentAvailableMethod } from '../../../models/Payment/PaymentAvailableMethod.js';
import { PaymentMethod } from '../../../models/Payment/PaymentMethod.js';
import { PaymentType } from '../../../models/Payment/PaymentType.js';

class PaymentMethods {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get() {
    const requestContext = this.apiClient.getRequestContext();
    const fallbackPaymentMethods = [new PaymentAvailableMethod(PaymentMethod.CREDITCARD3DSECURE, PaymentType.DIRECT), new PaymentAvailableMethod(PaymentMethod.PAYPAL, PaymentType.DIRECT)];
    return this.apiClient.get('/com/payment-methods', {
      platform: requestContext === null || requestContext === void 0 ? void 0 : requestContext.platform,
      country: requestContext === null || requestContext === void 0 ? void 0 : requestContext.platform_country
    }).then(response => response.data.map(PaymentAvailableMethod.createFromResponse)).catch(() => fallbackPaymentMethods);
  }
}

export { PaymentMethods };
//# sourceMappingURL=PaymentMethods.js.map
